import { headerAxiosAuth, objectToQuerystring, handleBadRequestMsj } from "utils";
import config from "config";
import axios from "axios";

export const filtersRetailUser = async (query) => {
  try {
    const { data } = await axios.get(
      `${config.urlApi}/softretail/users/filters${objectToQuerystring(query)}`,
      {
        headers: headerAxiosAuth(localStorage.token),
      },
    );
    return data;
  } catch ({ response }) {
    return [];
  }
};

export const fetchRetailUser = async (query = {}) => {
  try {
    const url = `${config.urlApi}/softretail/users${objectToQuerystring(query)}`;
    console.info(url);
    const { data } = await axios.get(url, {
      headers: headerAxiosAuth(localStorage.token),
    });
    return data;
  } catch ({ response }) {
    return [];
  }
};

export const fetchRetailSales = async (query = {}) => {
  try {
    const url = `${config.urlApi}/softretail/sales${objectToQuerystring(query)}`;
    console.info(url);
    const { data } = await axios.get(url, {
      headers: headerAxiosAuth(localStorage.token),
    });
    return data;
  } catch ({ response }) {
    return [];
  }
};

export const fetchRetailDailyDepartmentSales = async (query = {}) => {
  try {
    const url = `${config.urlApi}/softretail/daily-department-sales${objectToQuerystring(query)}`;
    console.info(url);
    const { data } = await axios.get(url, {
      headers: headerAxiosAuth(localStorage.token),
    });
    return data;
  } catch ({ response }) {
    return [];
  }
};

export const PostUploadDailyDepartmentSales = async (values) => {
  try {
    const { data } = await axios.post(
      `${config.urlApi}/softretail/daily-department-sales/bulk`,
      values,
      {
        headers: headerAxiosAuth(localStorage.token),
      },
    );
    return data;
  } catch ({ response }) {
    handleBadRequestMsj(response, "");
    return false;
  }
};

export const fetchRetailBiOverview = async (query = {}, requestConfig = {}) => {
  try {
    const url = `${config.urlApi}/softretail/bi/overview${objectToQuerystring(query)}`;
    const { data } = await axios.get(url, {
      headers: headerAxiosAuth(localStorage.token),
      ...requestConfig,
    });
    return data;
  } catch (error) {
    if (axios.isCancel(error)) {
      throw error;
    }
    return null;
  }
};

export const fetchRetailBiDailySeries = async (query = {}, requestConfig = {}) => {
  try {
    const url = `${config.urlApi}/softretail/bi/daily-series${objectToQuerystring(query)}`;
    const { data } = await axios.get(url, {
      headers: headerAxiosAuth(localStorage.token),
      ...requestConfig,
    });
    return data;
  } catch (error) {
    if (axios.isCancel(error)) {
      throw error;
    }
    return [];
  }
};

export const fetchRetailBiRankings = async (query = {}, requestConfig = {}) => {
  try {
    const url = `${config.urlApi}/softretail/bi/rankings${objectToQuerystring(query)}`;
    const { data } = await axios.get(url, {
      headers: headerAxiosAuth(localStorage.token),
      ...requestConfig,
    });
    return data;
  } catch (error) {
    if (axios.isCancel(error)) {
      throw error;
    }
    return {
      topStores: [],
      topDepartments: [],
      topProducts: [],
      topReturnedProducts: [],
    };
  }
};

export const fetchRetailBiStoresAll = async (query = {}, requestConfig = {}) => {
  try {
    const url = `${config.urlApi}/softretail/bi/rankings/stores-all${objectToQuerystring(query)}`;
    const { data } = await axios.get(url, {
      headers: headerAxiosAuth(localStorage.token),
      ...requestConfig,
    });
    return Array.isArray(data) ? data : [];
  } catch (error) {
    if (axios.isCancel(error)) {
      throw error;
    }
    return [];
  }
};

export const fetchRetailBiTicketMetrics = async (query = {}, requestConfig = {}) => {
  try {
    const url = `${config.urlApi}/softretail/bi/ticket-metrics${objectToQuerystring(query)}`;
    const { data } = await axios.get(url, {
      headers: headerAxiosAuth(localStorage.token),
      ...requestConfig,
    });
    return data;
  } catch (error) {
    if (axios.isCancel(error)) {
      throw error;
    }
    return {
      dailySeries: [],
      dailySeriesByStore: [],
      topStoresByAvgTicket: [],
      topStoresByInvoiceTotal: [],
      hourlyTicketsSeries: [],
      hourlySalesSeries: [],
    };
  }
};

export const fetchRetailBncPayments = async (query = {}, requestConfig = {}) => {
  try {
    const url = `${config.urlApi}/softretail/bnc-payments${objectToQuerystring(query)}`;
    const { data } = await axios.get(url, {
      headers: headerAxiosAuth(localStorage.token),
      ...requestConfig,
    });
    return Array.isArray(data) ? data : [];
  } catch (error) {
    if (axios.isCancel(error)) {
      throw error;
    }
    return [];
  }
};

export const filterRetailSales = async (query = {}) => {
  try {
    const url = `${config.urlApi}/softretail/sales/filters${objectToQuerystring(query)}`;
    console.info(url);
    const { data } = await axios.get(url, {
      headers: headerAxiosAuth(localStorage.token),
    });
    return data;
  } catch ({ response }) {
    return [];
  }
};

export const IndexRetailUser = async (id) => {
  try {
    const { data } = await axios.get(`${config.urlApi}/softretail/users/${id}`, {
      headers: headerAxiosAuth(localStorage.token),
    });
    return data;
  } catch ({ response }) {
    return null;
  }
};

export const CommandChangePasswordUser = async (id) => {
  try {
    const { data } = await axios.post(
      `${config.urlApi}/softretail/users/${id}/change_password`,
      {},
      {
        headers: headerAxiosAuth(localStorage.token),
      },
    );
    return data;
  } catch ({ response }) {
    handleBadRequestMsj(response, "RetailUsers");
    return false;
  }
};

export const SendEmailRetailUser = async (id) => {
  try {
    const { data } = await axios.post(
      `${config.urlApi}/softretail/users/${id}/email`,
      {},
      {
        headers: headerAxiosAuth(localStorage.token),
      },
    );
    return data;
  } catch ({ response }) {
    handleBadRequestMsj(response, "RetailUsers");
    return false;
  }
};

export const PutRetailUser = async (id, values) => {
  try {
    const { data } = await axios.put(`${config.urlApi}/softretail/users/${id}`, values, {
      headers: headerAxiosAuth(localStorage.token),
    });
    return data;
  } catch ({ response }) {
    handleBadRequestMsj(response, "RetailUsers");
    return false;
  }
};
